module.exports = __webpack_public_path__ + "static/media/quote-icon.549a2927.svg";